<template>
    <header :class="['header', modify]">
        <div class="grid__container header__container">
            <div class="header__row">
                <div class="header__left">
                    <a
                        v-if="emptyHeader"
                        href="/"
                        class="header__logo">
                        <IconLogo />
                    </a>
                    <div
                        v-else
                        class="header__logo">
                        <IconLogo />
                    </div>
                </div>
                <div
                    v-if="!hideItems"
                    class="header__center">
                    <nav class="header__navigation">
                        <template v-for="item in menuItems">
                            <router-link v-if="!item.hide"
                                         :key="item.link"
                                         :to="item.link"
                                         active-class="is-active"
                                         class="header__navigation-link">
                                <component :is="item.icon"
                                           v-if="item.icon && item.isIconDesktop" />
                                <template v-else>
                                    {{ item.name }}
                                </template>
                            </router-link>
                        </template>
                    </nav>
                </div>
                <div
                    v-if="!hideItems"
                    class="header__right">
                    <router-link
                        to="/report-problems"
                        class="header__navigation-link">
                        <IconAlertOutlineWhite class-name="icon-fill" />
                        Сообщить о проблеме
                    </router-link>
                    <span class="header__callback-link"
                          @click="showCallbackForm">
                        Обратная связь
                    </span>
                    <div v-click-outside="hideMenu"
                         class="header__auth">
                        <a href="#"
                           class="header__auth-name"
                           @click.prevent="toggleMenu">
                            {{ getSurname }}
                            <span>{{ getFirstName }}</span>
                        </a>
                        <PopupMenu ref="headerPopupMenu" />
                    </div>
                    <MobileMenu :menu-items="menuItems"
                                @changeMobileMenu="changeLayerHeader" />
                    <STPopup ref="callbackPopupHeader"
                             :icon-close-big="false"
                             modify="popup_middle_size popup_center_position">
                        <Callback @close="hideCallbackForm" />
                    </STPopup>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import Callback from '@/components/Forms/RequestCallback/RequestCallback';
import IconAlertOutlineWhite from '@/components/Icons/AlertOutlineWhite';
import IconHome from '@/components/Icons/Home';
import IconLogo from '@/components/Icons/Logo';
import MobileMenu from '@/sections/MobileMenu/MobileMenu';
import PopupMenu from './Templates/PopupMenu';

export default {
    name: 'TheHeader',

    components: {
        Callback,
        IconAlertOutlineWhite,
        IconHome,
        IconLogo,
        MobileMenu,
        PopupMenu
    },

    directives: {
        ClickOutside
    },

    props: {
        hideItems: {
            type   : Boolean,
            default: false
        }
    },

    data() {
        return {
            modify     : '',
            emptyHeader: false,
            menuItems  : [
                /*{ hide: false, link: '/real-estate', name: 'Недвижимость', icon: 'IconHome' },
                { hide: false, link: '/documents', name: 'Документы', icon: 'IconDocumentSmall' },*/
                { hide: false, link: '/parametric', name: 'Недвижимость', icon: 'IconHome' },
                { hide: false, link: '/appointments', name: 'Записаться в офис', icon: 'IconHome' },
                { hide: false, link: '/deals', name: 'Сделки', icon: 'IconDocumentSmall' },
                { hide: false, link: '/faq', name: 'Вопросы и ответы', icon: 'IconList' },
                { hide: false, link: '/news', name: 'Акции и новости', icon: 'IconNews' }
            ]
        };
    },

    computed: {
        ...mapGetters({
            userData: 'GET_USER',
            token   : 'GET_TOKEN'
        }),

        getSurname() {
            return this.userData && this.userData.surname ? this.userData.surname[0] : '';
        },

        getFirstName() {
            return this.userData && this.userData.firstName ? this.userData.firstName[0] : '';
        }
    },

    mounted() {
        this.emptyHeader = Boolean(this.$route.meta.hideHeaderItems);
    },

    methods: {
        ...mapActions(['logout']),

        /**
         * Открывает выпадающее меню
         */
        toggleMenu() {
            if (!this.$refs.headerPopupMenu) {
                return;
            }

            this.$refs.headerPopupMenu.toggleMenu();
        },

        /**
         * Закрывает выпадающее меню
         */
        hideMenu() {
            if (!this.$refs.headerPopupMenu) {
                return;
            }

            this.$refs.headerPopupMenu.hideMenu();
        },

        /**
         * Изменяет z-index хедера
         * @param value
         */
        changeLayerHeader(value) {
            this.modify = value ? 'is-open' : '';
        },

        /**
         * Открывает форму обратного звонка
         */
        showCallbackForm() {
            this.$refs.callbackPopupHeader.open();
        },

        /**
         * Закрывает форму обратного звонка
         */
        hideCallbackForm() {
            this.$refs.callbackPopupHeader.close();
        }
    }
};
</script>

<style lang="scss">
    @import "Header";
</style>
